import { render, staticRenderFns } from "./UtmAttribution.vue?vue&type=template&id=297c5f72&scoped=true"
import script from "./UtmAttribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./UtmAttribution.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UtmAttribution.vue?vue&type=style&index=0&id=297c5f72&prod&scoped=true&lang=scss"
import style1 from "./UtmAttribution.vue?vue&type=style&index=1&id=297c5f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c5f72",
  null
  
)

export default component.exports